import React from 'react';

//material UI
import Typography from '@material-ui/core/Typography';

const LoginFormContentHeader = ({ classes }) => {
  return (
    <div className={classes.header}>
      <div className={classes.headerText}>
        <Typography
          className={(classes.typography, 'loginHeader')}
          component='h1'
          variant='h5'
          style={{ fontWeight: '600', fontSize: '2rem', marginBottom: '15px' }}
        >
          Weaviate Console
        </Typography>
        <div className='wcsBox'>
          <p>
            This is the legacy console for the Weaviate Cloud Service. In order
            to make use of our latest features and create sandboxes as well as
            managed clusters, please use the{' '}
            <a href='https://console.weaviate.cloud/'>new console</a> instead by
            visiting:
          </p>
          <a href='https://console.weaviate.cloud/' className='wcsLinkButton'>
            New Weaviate Console
          </a>
        </div>
        <Typography className={classes.typography}>
          connect to the Weaviate Cloud Services or <br></br> to a local
          Weaviate
        </Typography>
      </div>
    </div>
  );
};

export default LoginFormContentHeader;
